import {Component, OnDestroy, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {EventsSummaryService} from '../../../core/services/events-summary.service';
import {IExcelColumn} from '../../model/interface/excel-column.interface';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {EventService} from '../../../core/services/event.service';
import {ISimpleSelectableDataList} from '../../model/interface/simple-selectable-data.model.interface';
import {map} from 'rxjs/operators';
import {IEventTypeHelper} from '../../helper/i-event-type.helper';
import {RequestProcessor} from '../../utils/request-processor';
import {DefaultColumnFormComponent} from "../../column-select/default-column-form/default-column-form.component";
import {IEventsSearch} from "../../model/interface/events-search";
import {DictionaryPosition} from "../../model/dictionary.model";

@Component({
  selector: 'app-events-summary',
  templateUrl: './events-summary.component.html',
  styleUrls: ['./events-summary.component.css']
})
export class EventsSummaryComponent implements OnInit, OnDestroy {
  availableEventType: ISimpleSelectableDataList;
  isEditable = true;
  firstFormGroup: FormGroup

  @ViewChild('container', {read: ViewContainerRef}) container: ViewContainerRef;

  availableColumns: IExcelColumn[];
  form: FormGroup;

  get columns() {
    return this.form.get('columns') as FormArray;
  }

  constructor(private eventsSummaryService: EventsSummaryService,
              private eventService: EventService,
              private matDialogRef: MatDialogRef<EventsSummaryComponent>,
              private requestProcessor: RequestProcessor,
              private fb: FormBuilder) {
  }

  ngOnInit(): void {
    this.createForm()
    this.fetchAvailableEventType();
    this.fetchAvailableColumn();
    this.form = this.fb.group({
      columns: new FormArray([])
    })
  }

  createForm() {
    this.firstFormGroup = this.fb.group({
      date: [null, Validators.required],
      types: [null],
      legalCaseDate: [null],
      lessorId: [null]
    });
  }

  fetchAvailableEventType() {
    this.eventService.getAllAvailableForUserTypes()
      .pipe(
        map((eventTypes) => IEventTypeHelper.toSimpleSelectableDataList(eventTypes))
      ).subscribe(eventType => {
      this.availableEventType = eventType
    });
  }

  fetchAvailableColumn() {
    this.eventsSummaryService.getColumns().subscribe(columns => {
      this.availableColumns = columns.data;
    });
  }

  selectAll() {
    this.columns.controls.filter(c => !(c instanceof FormArray)).forEach(control => control.patchValue({select: true}))
  }

  unselectAll() {
    this.columns.controls.filter(c => !(c instanceof FormArray)).forEach(control => control.patchValue({select: false}))
  }

  protected _createCheckboxForms() {
    this.container.clear();
    this.columns.clear();
    this.availableColumns.forEach((column) => {
      const componentRef = this.container.createComponent(DefaultColumnFormComponent);
      componentRef.instance.column = column;
      this.columns.push(componentRef.instance.resultForm);
    });
  }

  ngOnDestroy(): void {
    this.container.clear();
  }

  export() {
    const payload = this._createPayload();
    const search = this._createSearch(this.firstFormGroup.value)
    const data = this.eventsSummaryService.export(search, payload)
    this.requestProcessor.displayOnSuccess(data, DictionaryPosition.REPORT_ORDERED);
    this.matDialogRef.close();
  }

  private _createPayload() {
    return {
      columns: this.getSelectedColumns()
    };
  }

  private _createSearch(form) {
    return {
      dateTimeAfter: form.date?.from?.format('YYYY-MM-DD'),
      dateTimeBefore: form.date?.to?.format('YYYY-MM-DD'),
      typeId: form.types,
      legalCaseCoreCreatedAfter: form.legalCaseDate?.from?.format('YYYY-MM-DD'),
      legalCaseCoreCreatedBefore: form.legalCaseDate?.to?.format('YYYY-MM-DD'),
      lessorId: form.lessorId
    } as IEventsSearch;
  }

  getSelectedColumns() {
    return this.columns.value.flat()
      .filter(column => column.select)
      .map(({select, label, ...rest}) => rest);
  }
}
